import { CRUISING_CODES, ACTIVITIES } from './Constants';

const getInfoItinerary = (days, ports) => {
  const listDays = days || [];
  const listPorts = ports || [];
  const result = [];
  const dailyPorts = [];
  const filteredPorts = [];

  listPorts.map(p => {
    if (!CRUISING_CODES.includes(p.code)) {
      filteredPorts.push(p);
    }
  });

  listDays.forEach(element => {
    const allPorts = element.ports ? element.ports : [];
    allPorts.forEach(port => {
      if (!result[port.activity]) result[port.activity] = [];
      if (
        !CRUISING_CODES.includes(port?.port?.code) &&
        ACTIVITIES.includes(port.activity)
      ) {
        result[port.activity].push(port.port);
        if (port?.port?.region) dailyPorts.push(port.port);
      }
    });
  });

  const [embark] = Array.isArray(result['EMBARK']) ? result['EMBARK'] : [];
  const [debark] = Array.isArray(result['DEBARK']) ? result['DEBARK'] : [];

  return {
    embark,
    debark,
    dailyPorts,
    filteredPorts,
  };
};
export default getInfoItinerary;
